import { cn } from "@/lib/utils";
import { colorFromString } from "@/lib/utils";

interface Props {
  name: string;
  initials: string;
  size?: number;
  className?: string;
  src?: string | null;
}

export function Avatar({ name, initials, size = 36, className, src }: Props) {
  const bg = colorFromString(name);
  return (
    <div
      className={cn(
        "relative flex shrink-0 items-center justify-center overflow-hidden rounded-full text-white font-medium select-none",
        className
      )}
      style={{ width: size, height: size, background: bg, fontSize: size * 0.4 }}
    >
      {src ? <img src={src} alt={name} className="h-full w-full object-cover" /> : initials}
    </div>
  );
}
